export const ADD_UNIT_ONBOARD_ROUTE_PATH = '/onboard-add-unit/:propertyId';
export const ADD_TENANT_ONBOARD_ROUTE_PATH = '/onboard-add-tenants/:uuid';
